<template>
    <main-content with_go_back_bar>
        <ul class="nav nav-pills" role="tablist">
            <button class="btn btn-primary" >
                {{ $t('accounting.label.records') }}
            </button>
        </ul>


        <div class="tab-content">
            <kt-datatable
            v-bind="dataTableRecords"
            >

            </kt-datatable>
        </div>
    </main-content>
</template>

<script>

import MainContent from "@/components/main-content.vue";
import { StarShopApiUrl } from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import recordAccessColumns from "./datatable/recordAccessColumns";

export default {
  name: "StarshopAccountingDetail",
  components: {MainContent},
  data() {
    return {
        account_hashid: null,
    }
  },
  
  computed: {
    dataTableRecords() {
        return {
            id: "accounting_records_details",
            data: {
                type: "remote",
                source: {
                    read: {
                        url: StarShopApiUrl.path("accounting/admin/account/records/" + this.$route.params.hashid),
                        method: "GET",
                        headers: AuthorizationHeader,
                        map: (res) => res.data.data,
                        params: {
                            // hashid: this.$route.params.hashid
                            // query: this.account_hashid
                        },
                    },
                },
                pageSize: 15,
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true
            },
            pagination: false,
            sortable: false,
            columns: [...recordAccessColumns],
            // actions: recordActionColumn
        }
    }
  },

  mounted() {
    this.account_hashid = this.$route.params.hashid
  },
};
</script>

<style scoped></style>
